export class DomainQuery {
    constructor() {
        this._fields = [];
        this._filters = [];
        this._sorts = [];
    }
    get fields() {
        return this._fields;
    }
    get filters() {
        return this._filters;
    }
    get sorts() {
        return this._sorts;
    }
    onField(...field) {
        field.forEach((f) => this.fields.push(f));
        return this;
    }
    onFilter(...filters) {
        filters.forEach((f) => this.filters.push(f));
        return this;
    }
    onSort(...sorts) {
        sorts.forEach((s) => this.sorts.push(s));
        return this;
    }
}
